module.exports = __webpack_public_path__ + "img/about-icon-05.a2881bd4.svg";